import {
    Accordion, AccordionDetails,
    IconButton,
    AccordionSummary, Box, Button, CircularProgress, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography
} from '@material-ui/core'
import React, { useRef } from 'react';
import { useStyles } from './styles';
import 'react-credit-cards/es/styles-compiled.css'
import Cards from 'react-credit-cards';
import { FiMinusCircle, FiPlusCircle } from 'react-icons/fi';
import * as popUpActionCreator from "../../../store/Actions/globalpopupAlert";
// import TableBodyData from './TableBodyData';
import Backdrop from '../../../components/Modal/Backdrop';
import Switch from '@mui/material/Switch';
import Modal from '../../../components/Modal/Modal'
// import AddEfoneNumber from './AddNumber/AddEfoneNumber';
import billingServices from '../billingServices.tsx/billingServices'
import axiosInstance from '../../../environment/axiosInstance'
import { Pagination, Stack } from '@mui/material';
import { BorderColor, Delete, } from '@material-ui/icons';
import { useHistory } from "react-router-dom";
import TableBodyData from './TableBodyData';
import Moment from 'moment'
import AddLicenses from './AddLicenses';
import { connect } from "react-redux";


function Billing(props:any) {
    const accordion1Ref = useRef<any>(null);
  const accordion2Ref = useRef<any>(null);
  const accordion3Ref = useRef<any>(null);
  const accordion4Ref = useRef<any>(null);
    const classes = useStyles()
    const [openExpand, setOpenExpand] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [loadingBilling, setLoadingBilling] = React.useState(false);
    const [defaultLicenses, setDefaultLicenses] = React.useState<any>()
    const [paymentInfo, setPaymentInfo] = React.useState<any>([])
    const [billingInfo, setBillingInfo] = React.useState<any>([])
    const [addModal, setAddModal] = React.useState(false)
    const [openModal, setOpenModal] = React.useState(false);
    const [purchaseLicenseModal, setPurchaseLicenseModal] = React.useState(false);
    const [selectedCardId, setSelectedCardId] = React.useState(null);
    const [deleteModal, setDeleteModal] = React.useState(false)
    const [cardDetails, setCardDetails] = React.useState<any>({
        number: '',
        cvv: '',
        expiry: "",
        focused:""
      })
    const [delId, setDelId] = React.useState<any>('')
    const expandOpen = () => {
        setOpenExpand(!openExpand)
    }

    const handlePopupPurchaseLicenses = () => {
        setPurchaseLicenseModal(!purchaseLicenseModal)
    }

    const handleChange = (event: any, cardId: any) => {
        setSelectedCardId(cardId);
        setOpenModal(true);
        setAddModal(false)

    };

    const handleClose = () => {
        setOpenModal(false);
        setSelectedCardId(null);
        setAddModal(false)
    };


    const fetchDefaultLicenses = () => {
        billingServices.getDefaultLicenses().then((res: any) => {
            if (res.success) {
                setDefaultLicenses(res?.data)
            } else {

            }
        }).catch((err: any) => {

        })
    }

    const handleDeleteModal = (id: any) => {
        setDeleteModal(!deleteModal)
        setDelId(id)
      }

      const handleDeleteClose = () => {
        setDeleteModal(!deleteModal)
      }

      const handleScrollToAccordion3 = () => {
        if (accordion3Ref.current) {
          accordion3Ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
    

    const deletePaymentInfo = () => {
        billingServices.DeletePaymentInfo(delId).then((res: any) => {
            if (res.success) {
                setDeleteModal(!deleteModal)
                fetchPaymentInfo()
            } else {
            }
        }).catch((err: any) => {
        })
    }

    const primaryModal = (id: any) => {
        axiosInstance.patch(`/addons/cards?cardId=${id}`,).then((res: any) => {
            if (res.status === 200) {
                fetchPaymentInfo()
            }
        })
            .catch((error) => {
                console.error("Error updating card as primary:", error);
            });
    }
    const handleConfirm = () => {
        primaryModal(selectedCardId);
        handleClose();
    };

    const getNextBillingHistoryData = () => {
        setLoadingBilling(true)
        var data = {
            next_offset: billingInfo?.next_offset
        }
        billingServices.getBillingHistory(data).then((res: any) => {
            if (res.success) {
                setLoadingBilling(false)
                setBillingInfo(res?.data)
            } else {

            }
        }).catch((err: any) => {

        })
    }

    const fetchBillingHistory = () => {
        setLoadingBilling(true)
        var data = {
            next_offset: billingInfo?.next_offset
        }
        billingServices.getBillingHistory(data).then((res: any) => {
            if (res.success) {
                setLoadingBilling(false)
                setBillingInfo(res?.data)
            } else {

            }
        }).catch((err: any) => {

        })
    }

    const fetchPaymentInfo = () => {
        setLoading(true)
        billingServices.getPaymentInfo().then((res: any) => {
            if (res.success) {
                setLoading(false)
                setPaymentInfo(res?.data?.cardsList)
            } else {

            }
        }).catch((err: any) => {

        })
    }

    React.useEffect(() => {
        fetchDefaultLicenses()
        fetchPaymentInfo()
        fetchBillingHistory()
    }, [])

    const handlePopupModalAddCard = () => {
        setAddModal(true)
        setOpenExpand(true)
    }

    const handlePopupModalAddCardClose = () => {
        setAddModal(false)
        setOpenExpand(true)
    }


    const handleSubmitCard = (e: any) => {
        e.preventDefault();
        const inputValue = cardDetails.expiry;
        const parts = inputValue.split('/');
        let firstPart = 0;
        let secondPart = 0;
        if (parts.length === 2) {
          firstPart = parseInt("20" + parts[1]); // Add 20 to the first part
          secondPart = parseInt(parts[0]);
        }
    
        var data = {
          number: cardDetails.number, 
          cvv: cardDetails.cvv,
          expiry_year: firstPart,
          expiry_month: secondPart
        }

            axiosInstance.post('/addons/cards', data).then((response: any) => {
                if (response.status === 200) {
                    props.popUpAlert(response.data.message, "UPDATE_AGENT_SUCCESS", "success");
                    setAddModal(false)
                    fetchPaymentInfo()
                }else{
                    props.popUpAlert(response.data.message, "UPDATE_AGENT_FAILURE", "error");
                }
            })
            .catch((err: any) => {
                props.popUpAlert(err.response.data.message, "UPDATE_AGENT_FAIL", "error");
              })
    
      }

      const clearNumber = (value: any) => {
        return value.replace(/\D+/g, '')
      }
    
      const formatExpirationDate = (value: any) => {
        const clearValue = clearNumber(value)
    
        if (clearValue.length >= 3) {
          return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`
        }
    
        return clearValue
      }
    
      const handleInputChange = (e: any) => {
        if (e.target.name === 'expiry') {
          e.target.value = formatExpirationDate(e.target.value)
          setCardDetails((prev: any) => {
            return {
              ...prev,
              expiry: e.target.value
            }
          })
        }
        setCardDetails((prev: any) => {
          return {
            ...prev,
            [e.target.name]: e.target.value
          }
        })
      }
    
      const handleInputFocus = (target: any) => {
        setCardDetails((prev: any) => {
          return {
            ...prev,
            focused: target.name
          }
        })
      }
    





    //console.log('depttttttData',deptData,userList);

    const [search, setSearch] = React.useState('')

    return (
        <>

            {
                addModal && (
                    <div>
                        <Backdrop handlePopupModal={handlePopupModalAddCard} />
                        <Modal title={"Enter Payment Card Details"} handlePopupModal={handlePopupModalAddCardClose}>
            <div id="PaymentForm">
              <Cards
                number={cardDetails.number}
                name={cardDetails.first_name}
                expiry={cardDetails.expiry}
                cvc={cardDetails.cvv}
                focused={cardDetails.focused}
              />
              <form >
                <div className='form-group'>
                  <Grid item md={12} style={{ display: "flex" }}>
                    <Grid item md={4} style={{ margin: "16px" }}>
                      <small>Card Number:</small>
                    </Grid>
                    <Grid item md={8}>
                      <input
                        type='tel'
                        name='number'
                        style={{ margin: "18px" }}
                        className='form-control'
                        placeholder='Card Number'
                        pattern='[\d| ]{16,22}'
                        maxLength={16}
                        required
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                      />
                    </Grid>
                  </Grid>
                </div>

                <div className='form-group'>
                  <Grid item md={12} style={{ display: "flex" }}>
                    <Grid item md={4} style={{ margin: "16px" }}>
                      <small>Expiration Date:</small>
                    </Grid>
                    <Grid item md={8}>
                      <input
                        type='tel'
                        name='expiry'
                        style={{ margin: "18px" }}
                        className='form-control'
                        placeholder='MM/YY'
                        pattern='\d\d/\d\d'
                        required
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className='form-group'>
                  <Grid item md={12} style={{ display: "flex" }}>
                    <Grid item md={4} style={{ margin: "16px" }}>
                      <small>CVC:</small>
                    </Grid>
                    <Grid item md={8}>

                      <input
                        type='tel'
                        name='cvv'
                        className='form-control'
                        placeholder='Cvv'
                        style={{ margin: "18px" }}
                        pattern='\d{3}'
                        required
                        maxLength={3}
                        onChange={handleInputChange}
                        onFocus={handleInputFocus}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className='form-actions' style={{ textAlign: "center", cursor: "pointer" }}>
                  <button className={classes.yesButton} style={{ cursor: "pointer" }} onClick={handleSubmitCard}>Submit</button>
                </div>
              </form>

            </div>
          </Modal>
                        {/* <Modal title="Add Card" handlePopupModal={handlePopupModalAddCardClose}>
                            <div className="add_user_popup" style={{ width: "500px", padding: '10px 40px 10px 30px' }}>
                                <AddCard
                                    handlePopupModal={handlePopupModalAddCardClose}
                                    fetchPaymentInfo={fetchPaymentInfo}
                                />
                            </div>
                        </Modal> */}
                    </div>
                )
            }

{
        deleteModal && (
          <div>
            <Backdrop handlePopupModal={handleDeleteModal} />
            <Modal title={""} handlePopupModal={handleDeleteModal} >
            <div className="add_user_popup" style={{ width: "500px", padding: '10px 40px 10px 30px' }}>
                            <div >
                                <div id="confirmation-modal" style={{ fontSize: "28px", textAlign: "center" }}>Confirm Action</div>
                                <p style={{ padding: "13px", fontSize: "16px", textAlign: "center" }} id="confirmation-modal-description">Are you sure you want to delete?</p>
                                <div style={{ justifyContent: "center", display: "flex", gap: "10px" }}>
                                    <Button variant="contained" color="primary" onClick={deletePaymentInfo}>Delete</Button>
                                    <Button variant="contained" color="secondary" onClick={handleDeleteClose}>Cancel</Button>
                                </div>
                            </div>
                        </div>
            </Modal>
          </div>
        )
      }

            {openModal && (
                <div>
                    <Backdrop handlePopupModal={handleChange} />
                    <Modal title="Make it Primary" handlePopupModal={handleClose}>
                        <div className="add_user_popup" style={{ width: "500px", padding: '10px 40px 10px 30px' }}>
                            <div >
                                <div id="confirmation-modal" style={{ fontSize: "28px", textAlign: "center" }}>Confirm Action</div>
                                <p style={{ padding: "13px", fontSize: "16px", textAlign: "center" }} id="confirmation-modal-description">Are you sure you want to set this card as primary?</p>
                                <div style={{ justifyContent: "center", display: "flex", gap: "10px" }}>
                                    <Button variant="contained" color="primary" onClick={handleConfirm}>Yes</Button>
                                    <Button variant="contained" color="secondary" onClick={handleClose}>No</Button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            )
            }
             {purchaseLicenseModal && (
                <div>
                    <Backdrop handlePopupModal={handlePopupPurchaseLicenses} />
                    <Modal title="Purchase Licenses" handlePopupModal={handlePopupPurchaseLicenses}>
                   
                    <AddLicenses
                    handlePopupPurchaseLicenses={handlePopupPurchaseLicenses}
                    handleScrollToAccordion3={handleScrollToAccordion3}
                    fetchDefaultLicenses={fetchDefaultLicenses}
                    />
                       
                    </Modal>
                </div>
            )
            }
            <Accordion 
            ref={accordion1Ref}
            expanded={openExpand}
                // onChange={expandOpen}
                >
                <AccordionSummary
                    expandIcon={openExpand ? <FiMinusCircle color="lightgrey" onClick={expandOpen} /> : <FiPlusCircle color="#2645ad" onClick={expandOpen} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                > <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>

<Typography className={classes.heading}>Current Plan (Pro)</Typography>

                <Button className={classes.gridItem}
                    size="small"
                    variant='outlined'
                    color='primary'
                    onClick={handlePopupPurchaseLicenses}
                >
                    Purchase Licenses
                </Button>
            </div>
                  
                </AccordionSummary>
                <Divider className={classes.divider} />
                <AccordionDetails className={classes.accordianNoFlex}>
                    <Grid item md={12} className={classes.flex}>
                        <Grid item md={6}>
                            <Typography className={classes.typography}>Current billing Cycle</Typography>
                            <Typography className={classes.typography}>{defaultLicenses?.currnetBillingCycle}</Typography>
                        </Grid>
                        <Grid item md={6}>
                            <Typography className={classes.typography}>Next billing Cycle</Typography>
                            <Typography className={classes.typography}>{defaultLicenses?.nextBillingDate}</Typography>
                        </Grid>
                    </Grid>

                    {defaultLicenses?.licenses?.map((item: any) => {
                        return (
                            <>
                                <Divider className={classes.divider} />
                                <Grid item md={12} className={classes.flex}>
                                    <Grid item md={6}>
                                        <Typography className={classes.typography}>{item?.licenseName}</Typography>
                                    </Grid>
                                    <Grid item md={4}>
                                        <Typography className={classes.typography}>{item?.quantity} x {item?.currency}${item?.cost}/mo</Typography>
                                    </Grid>
                                    <Grid item md={2} style={{ textAlign: "end" }}>
                                        <Typography className={classes.typography}>{item?.currency}${item?.totalCost}</Typography>
                                    </Grid>
                                </Grid>

                            </>
                        )
                    })}
                    <Divider className={classes.divider} />
                    <Grid item md={12} className={classes.flex}>
                        <Grid item md={6}>
                            <Typography className={classes.typography}>Next month's total</Typography>
                            <Typography >Estimated total at the end of the billing cycle,excluding any taxes or fees.</Typography>
                        </Grid>
                        <Grid item md={6} style={{ textAlign: "end" }}>
                            <Typography className={classes.totalAmount}>USD${defaultLicenses?.nextMonthTotal}</Typography>
                            <Typography >Save with annual billing.contact support to switch</Typography>
                        </Grid>
                    </Grid>


                </AccordionDetails>
            </Accordion>

            <Accordion 
            ref={accordion2Ref}
            expanded={openExpand}
                onChange={expandOpen}>
                <AccordionSummary
                    expandIcon={openExpand ? <FiMinusCircle color="lightgrey" onClick={expandOpen} /> : <FiPlusCircle color="#2645ad" onClick={expandOpen} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>Addons</Typography>
                </AccordionSummary>
                <Divider className={classes.divider} />
                <AccordionDetails>
                    <Grid container spacing={4}>
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <TableContainer className={classes.tableCard2} id="scrollbar">
                                <div className={classes.addonsTableHeading}>Call</div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ paddingLeft: 15, width: 100 }}>
                                                Name
                                            </TableCell>
                                            <TableCell className={classes.tableHead}>Qty</TableCell>
                                            <TableCell className={classes.tableHead}>Cost</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {defaultLicenses?.accountAddons[0]?.calls?.map((element: any) => (
                                            <>
                                                <TableBodyData
                                                    elementData={element}
                                                    title={"Call"}

                                                //  subscriptionType={subscriptionType}

                                                // setSubscriptionType={setSubscriptionType}
                                                />
                                            </>
                                        ))}
                                        {defaultLicenses?.accountAddons[0]?.calls.length > 0 ?
                                            <TableRow>
                                                <TableCell className={classes.tableBody} style={{ paddingLeft: 15 }}>
                                                </TableCell>
                                                <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>
                                                    Total
                                                </TableCell>
                                                <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>
                                                    USD${defaultLicenses?.accountAddons[0]?.callsSummary?.totalCost}
                                                </TableCell>
                                            </TableRow> : ""}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <TableContainer className={classes.tableCard2} id="scrollbar">
                                <div className={classes.addonsTableHeading}>SMS</div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ paddingLeft: 15, width: 100 }}>
                                                Name
                                            </TableCell>
                                            <TableCell className={classes.tableHead}>Qty</TableCell>
                                            <TableCell className={classes.tableHead}>Cost</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {defaultLicenses?.accountAddons[0]?.sms?.map((element: any) => (
                                            <TableBodyData
                                                elementData={element}
                                                title={"SMS"}
                                            />
                                        ))}
                                        {defaultLicenses?.accountAddons[0]?.sms.length > 0 ?
                                            <TableRow>
                                                <TableCell className={classes.tableBody} style={{ paddingLeft: 15 }}>
                                                </TableCell>
                                                <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>
                                                    Total
                                                </TableCell>
                                                <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>
                                                    USD${defaultLicenses?.accountAddons[0]?.smsSummary?.totalCost}
                                                </TableCell>
                                            </TableRow> : ""}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <TableContainer className={classes.tableCard2} id="scrollbar">
                                <div className={classes.addonsTableHeading}>Features</div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ paddingLeft: 15, width: 100 }}>
                                                Name
                                            </TableCell>
                                            <TableCell className={classes.tableHead}>Qty</TableCell>
                                            <TableCell className={classes.tableHead}>Cost</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {defaultLicenses?.accountAddons[0]?.features?.map((element: any) => (
                                            <TableBodyData
                                                elementData={element}
                                                title={"Features"}
                                            />

                                        ))}
                                        {defaultLicenses?.accountAddons[0]?.features.length > 0 ?
                                            <TableRow>
                                                <TableCell className={classes.tableBody} style={{ paddingLeft: 15 }}>
                                                </TableCell>
                                                <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>
                                                    Total
                                                </TableCell>
                                                <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>
                                                    USD${defaultLicenses?.accountAddons[0]?.featuresSummary?.totalCost}
                                                </TableCell>
                                            </TableRow> : ""}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                            <TableContainer className={classes.tableCard2} id="scrollbar">
                                <div className={classes.addonsTableHeading}>Phone Numbers</div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead} style={{ paddingLeft: 15, width: 100 }}>
                                                Name
                                            </TableCell>
                                            <TableCell className={classes.tableHead}>Qty</TableCell>
                                            <TableCell className={classes.tableHead}>Cost</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {defaultLicenses?.accountAddons[0]?.phoneNumbers?.map((element: any) => (
                                            <TableBodyData
                                                elementData={element}
                                                title={"Phone Numbers"}
                                                totalCost={defaultLicenses?.accountAddons[0]?.phoneNumbersSummary}
                                            />

                                        ))}
                                        {defaultLicenses?.accountAddons[0]?.phoneNumbers.length > 0 ?
                                            <TableRow>
                                                <TableCell className={classes.tableBody} style={{ paddingLeft: 15 }}>
                                                </TableCell>
                                                <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>
                                                    Total
                                                </TableCell>
                                                <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>
                                                    USD${defaultLicenses?.accountAddons[0]?.phoneNumbersSummary?.totalCost}
                                                </TableCell>
                                            </TableRow> : ""}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            <Accordion
            ref={accordion3Ref}
                expanded={openExpand}
            // onChange={expandOpen}
            >
                <AccordionSummary
                    expandIcon={openExpand ? <FiMinusCircle color="lightgrey" onClick={expandOpen} /> : <FiPlusCircle color="#2645ad" onClick={expandOpen} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>

                        <Typography className={classes.heading}>Payment Information</Typography>

                        <Button className={classes.gridItem}
                            size="small"
                            variant='outlined'
                            color='primary'
                            onClick={handlePopupModalAddCard}
                        >
                            Add Card
                        </Button>
                    </div>
                </AccordionSummary>
                <Divider className={classes.divider} />
                <AccordionDetails>
                    <Grid container spacing={4}>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <TableContainer className={classes.tableCard2} id="scrollbar">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {/* <TableCell className={classes.tableHead} >
                                                Card id
                                            </TableCell> */}
                                            <TableCell className={classes.tableHead}>Last 4 digit</TableCell>
                                            <TableCell className={classes.tableHead}>is Primary</TableCell>
                                            <TableCell className={classes.tableHead}>Brand</TableCell>
                                            <TableCell className={classes.tableHead}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {loading ?
                                        <TableBody>
                                            <Box sx={{ display: 'flex', marginTop: "25px", marginLeft: "520px" }}>
                                                <CircularProgress />
                                            </Box>
                                        </TableBody>
                                        :
                                        <TableBody>
                                            {paymentInfo?.map((element: any) => (
                                                <>
                                                    <TableRow key={element.cardId}>
                                                        {/* <TableCell className={classes.tableBody}>
                                                            {element.cardId}
                                                        </TableCell> */}
                                                        <TableCell className={classes.tableBody}>
                                                            {element.last4}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            <Switch
                                                                checked={element.isPrimary}
                                                                onChange={(e) => handleChange(e, element.cardId)}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                            />

                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            {element.brand}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            <IconButton className={classes.iconButton} onClick={() => handleDeleteModal(element.cardId)}>
                                                                <Delete className={classes.deleteIconColor} />
                                                                <Typography className={classes.deleteIconText}>Delete</Typography>
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ))}

                                        </TableBody>}
                                </Table>
                            </TableContainer>
                        </Grid>



                    </Grid>
                </AccordionDetails>


            </Accordion>

            <Accordion
            ref={accordion4Ref}
                expanded={openExpand}
            // onChange={expandOpen}
            >
                <AccordionSummary
                    expandIcon={openExpand ? <FiMinusCircle color="lightgrey" onClick={expandOpen} /> : <FiPlusCircle color="#2645ad" onClick={expandOpen} />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>

                        <Typography className={classes.heading}>Billing History</Typography>


                    </div>
                </AccordionSummary>
                <Divider className={classes.divider} />
                <AccordionDetails>
                    <Grid container spacing={4}>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <TableContainer className={classes.tableCard2} id="scrollbar">
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead}>
                                                Date
                                            </TableCell>
                                            <TableCell className={classes.tableHead}>Status</TableCell>
                                            <TableCell className={classes.tableHead}>Description</TableCell>
                                            <TableCell className={classes.tableHead}>Amount</TableCell>
                                            <TableCell className={classes.tableHead}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {loadingBilling ?
                                        <TableBody>
                                            <Box sx={{ display: 'flex', marginTop: "25px", marginLeft: "520px" }}>
                                                <CircularProgress />
                                            </Box>
                                        </TableBody>
                                        :
                                        <TableBody>
                                            {billingInfo?.invoices?.map((element: any) => (
                                                <>
                                                    <TableRow key={element.cardId}>
                                                        <TableCell className={classes.tableBody} >
                                                            {Moment.unix(element.due_date).format('MMM DD YYYY')}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                            {element.status}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody}>
                                                        </TableCell>

                                                        <TableCell className={classes.tableBody}>
                                                            {element.currency_code}${element?.amount_paid}
                                                        </TableCell>
                                                        <TableCell className={classes.tableBody} style={{ color: "#4D72F8" }}>
                                                            Add note
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ))}
                                            {billingInfo?.next_offset ?
                                                <TableRow>
                                                    <TableCell className={classes.tableBody} style={{ paddingLeft: 15 }}>
                                                    </TableCell>
                                                    <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>

                                                    </TableCell>
                                                    <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>

                                                    </TableCell>
                                                    <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>

                                                    </TableCell>
                                                    <TableCell className={classes.tableBody} style={{ fontWeight: 700, color: "black" }}>
                                                        <Button
                                                            onClick={getNextBillingHistoryData}
                                                            className={classes.gridItem}
                                                        >
                                                            Next
                                                        </Button>
                                                    </TableCell>
                                                </TableRow> : ""}

                                        </TableBody>
                                    }
                                </Table>
                            </TableContainer>
                        </Grid>



                    </Grid>
                </AccordionDetails>


            </Accordion>
        </>
    )
}

const mapDispatchToProps = (dipatches: any) => {
    return {
      popUpAlert: (err: any, instance: any, type: any) => dipatches(popUpActionCreator.initglobalPopup(err, instance, type))
    }
  }
  
  export default connect(null, mapDispatchToProps)(Billing)
